import * as ng from 'angular';
import {ValidationService} from '../../../services/validation.service';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {appContext} from '../../../app.context';

export class OrganizationDataController implements ng.IController {

  static $inject: string[] = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$state',
    'store',
    'ArchiSmallServices',
    '$sce',
    '$parse',
    '$uibModal',
    'ValidationService'
  ];

  constructor(
    private $rootScope: any,
    private $scope: any,
    private $timeout: ng.ITimeoutService,
    private $state: ng.ui.IStateService,
    private store: ng.a0.storage.IStoreService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: any,
    private $parse: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private _validationService: ValidationService
  ) {

    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    $scope.blacklistedPIVA = false;
    $scope.buttonDisabled = false;
    $scope.registerInProgress = false;
    $scope.validPIVA = true;
    $scope.identityCardMissing = false;
    $rootScope.formsubmitted = false;
    $scope.user = store.get('registeringUser');
    $scope.temporaryUser = ng.copy($scope.user);
    $scope.odinMessagePivaOrFiscalCodeMismatch = '';

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    if (!$scope.$parent.$parent.init()) {
      return;
    }

    let inscrizioneREAItem = {
      'ufficio': '',
      'numeroREA': '',
      'capitaleSociale': '',
      'socioUnico': '',
      'statoLiquidazione': ''
    };

    let stabileOrganizzazioneItem = {
      'address': '',
      'numeroCivico': '',
      'CAP': '',
      'province': '',
      'city': '',
      'country': '',
      'codicePaese': ''
    };

    let alboProfessionaleItem = {
      'alboProfessionale': '',
      'provinciaAlbo': '',
      'numeroIscrizioneAlbo': '',
      'dataIscrizioneAlbo': ''
    };

    let rappresentanteFiscaleItem = {
      'codicePaese': '',
      'PIVA': '',
      'fiscalCode': '',
      'denominazione': '',
      'nome': '',
      'cognome': '',
      'titolo': '',
      'codEORI': ''
    };

    $scope.validateActivationCodeAndPIVA = () => {

      let activationCode = $scope.user.subscription.activationCode;
      let PIVA = $scope.user.organizationData.PIVA;

      ArchiSmallServices.validateActivationCode(activationCode, PIVA)
        .then((response: any) => {
          if (response.isValid) {
            $scope.invalidPIVA = false;
          } else {
            $scope.invalidPIVA = false;
          }

          $scope.PIVAValid = $scope.PivaIsValid && !$scope.invalidPIVA;

        }, (error) => {
          if (error !== null) {
            if (error.errorCode === $rootScope.ArchiSmallERRORS.INVALID_PIVA) {
              $scope.invalidPIVA = true;
              $scope.PIVAValid = $scope.PivaIsValid && !$scope.invalidPIVA;
            }
          }

        });
    };
    $scope.validatePIVA = (PIVA) => {

      if (PIVA === null || PIVA === '') {
        $scope.validPIVA = true;
        return;
      }
      ArchiSmallServices.validatePIVA(PIVA)
        .then((response: any) => {

          $scope.blacklistedPIVA = false;
          $scope.validPIVA = response;
          $scope.PivaIsValid = $scope.validPIVA && !$scope.blacklistedPIVA;
        }, (error) => {
          if (error !== null) {
            if (error.errorCode === $rootScope.ArchiSmallERRORS.BLACKLISTED_PIVA) {
              $scope.blacklistedPIVA = true;
              $scope.PivaIsValid = $scope.validPIVA && !$scope.blacklistedPIVA;
            }
          }
        });
      $scope.validateActivationCodeAndPIVA();

    };

    $scope.validatePIVA($scope.user.organizationData.PIVA);

    $scope.changeIscrizioneREA = () => {
      $scope.user.organizationData.inscrizioneREA = (jQuery.extend(true, {}, inscrizioneREAItem));
    };

    $scope.changeIscrizioneREA();

    $scope.changeStabileOrganizzazione = () => {
      $scope.user.organizationData.stabileOrganizzazione = (jQuery.extend(true, {}, stabileOrganizzazioneItem));
    };

    $scope.changeAlboProfessionale = () => {
      $scope.user.organizationData.alboProfessionale = (jQuery.extend(true, {}, alboProfessionaleItem));
    };

    $scope.changeRappresentanteFiscale = () => {
      $scope.user.organizationData.rappresentanteFiscale = (jQuery.extend(true, {}, rappresentanteFiscaleItem));
    };

    switch ($scope.user.accountData.userType) {
      case 2:
        $scope.pageHeader = 'Registrazione Ditta Individuale';
        $scope.pageSubHeader = 'Dati Ditta Individuale';
        break;
      case 3:
        $scope.pageHeader = 'Registrazione Azienda';
        $scope.pageSubHeader = 'Dati Azienda';
        break;
    }

    switch ($scope.user.accountData.userType) {
      case 1:
        $state.go('registration.organization-data-lp');
        break;
      case 2:
      case 3:
        $state.go('registration.organization-data');
        break;
    }

    // <editor-fold desc='getTypeaheadValues'>
    $scope.refreshSedeStates = () => {
      let country = $scope.user.organizationData.codicePaese;
      ArchiSmallServices.getTypeaheadValues('state', 'country=' + country)
        .then((response: any) => {
          $scope.sedeStates = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshStabileStates = () => {
      let country = $scope.user.organizationData.stabileOrganizzazione.codicePaese;
      ArchiSmallServices.getTypeaheadValues('state', 'country=' + country)
        .then((response: any) => {
          $scope.stabileStates = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshStateCodes = () => {
      let country = 'IT';
      ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
        .then((response: any) => {
          $scope.stateCodes = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshCities = () => {
      let country = $scope.user.organizationData.codicePaese;
      let state = $scope.user.organizationData.province;
      ArchiSmallServices.getTypeaheadValues('municipality', 'country=' + country + '&state=' + state)
        .then((response: any) => {
          $scope.cities = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshStabileCities = () => {
      let country = $scope.user.organizationData.stabileOrganizzazione.codicePaese;
      let state = $scope.user.organizationData.stabileOrganizzazione.province;
      ArchiSmallServices.getTypeaheadValues('municipality', 'country=' + country + '&state=' + state)
        .then((response: any) => {
          $scope.citiesStabile = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getCAP = () => {
      ArchiSmallServices.getTypeaheadValues('cap', 'state=' + $scope.user.organizationData.province + '&city=' + $scope.user.organizationData.city)
        .then((response: any) => {
          // alert(response);
          if (response[0] !== '') {
            $scope.user.organizationData.CAP = response[0];
          }
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getStabileCAP = () => {
      ArchiSmallServices.getTypeaheadValues('cap', 'state=' + $scope.user.organizationData.stabileOrganizzazione.province + '&city=' + $scope.user.organizationData.stabileOrganizzazione.city)
        .then((response: any) => {
          // alert(response);
          if (response[0] !== '') {
            $scope.user.organizationData.stabileOrganizzazione.CAP = response[0];
          }
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshBirthCountries = () => {
      ArchiSmallServices.getTypeaheadValues('country')
        .then((response: any) => {
          $scope.birthCountries = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshBirthStates = () => {
      let country = $scope.user.organizationData.contactPerson.birthCountry === '' ? 'Italy' : $scope.user.organizationData.contactPerson.birthCountry;
      ArchiSmallServices.getTypeaheadValues('state', 'country=' + country)
        .then((response: any) => {
          $scope.birthStates = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshBirthCities = () => {
      let country = $scope.user.organizationData.contactPerson.birthCountry;
      let state = $scope.user.organizationData.contactPerson.birthProvince;
      ArchiSmallServices.getTypeaheadValues('municipality', 'country=' + country + '&state=' + state)
        .then((response: any) => {
          $scope.birthCities = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.sedeStates = [];
    $scope.stabileStates = [];
    $scope.cities = [];
    $scope.birthCountries = [];
    $scope.birthStates = [];
    $scope.birthCities = [];
    $scope.refreshSedeStates();
    $scope.refreshStabileStates();
    $scope.refreshStateCodes();
    $scope.refreshBirthStates();
    $scope.refreshBirthCountries();
    $scope.refreshCities();
    $scope.refreshStabileCities();
    $scope.regimeFiscaleValues = {
      'RF01': 'Ordinario',
      'RF02': 'Contribuenti minimi (art.1, c.96-117, L. 244/07)',
      'RF04': 'Agricoltura e attività connesse e pesca (artt.34 e 34-bis, DPR 633/72)',
      'RF05': 'Vendita sali e tabacchi (art.74, c.1, DPR. 633/72)',
      'RF06': 'Commercio fiammiferi (art.74, c.1, DPR 633/72)',
      'RF07': 'Editoria (art.74, c.1, DPR 633/72)',
      'RF08': 'Gestione servizi telefonia pubblica (art.74, c.1, DPR 633/72)',
      'RF09': 'Rivendita documenti di trasporto pubblico e di sosta (art.74, c.1, DPR 633/72)',
      'RF10': 'Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al DPR 640/72 (art.74, c.6, DPR 633/72)',
      'RF11': 'Agenzie viaggi e turismo (art.74-ter, DPR 633/72',
      'RF12': 'Agriturismo (art.5, c.2, L. 413/91) ',
      'RF13': 'Vendite a domicilio (art.25-bis, c.6, DPR 600/73) ',
      'RF14': 'Rivendita beni usati, oggetti d’arte, d’antiquariato o da collezione (art.36, DL 41/95)',
      'RF15': 'Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione (art.40-bis, DL 41/95) ',
      'RF16': 'IVA per cassa P.A. (art.6, c.5, DPR 633/72) ',
      'RF17': 'IVA per cassa (art. 32-bis, DL 83/2012) ',
      'RF18': 'Altro',
      'RF19': 'Regime forfettario (art.1, c.54-89, L. 190/2014)',
      'RF20': 'Regime transfrontaliero di Franchigia IVA (Direttiva UE 2020/285)'
    };
    $scope.socioUnicoValues = {
      'SU': 'socio unico',
      'SM': 'più soci',
    };
    $scope.statoLiquidazioneValues = {
      'LS': 'in liquidazione',
      'LN': 'non in liquidazione',
    };
    $scope.countriesCodeValues = {
      'IT': 'Italy',
      'AF': 'Afghanistan',
      'AX': 'Åland Islands',
      'AL': 'Albania',
      'DZ': 'Algeria',
      'AS': 'American Samoa',
      'AD': 'Andorra',
      'AO': 'Angola',
      'AI': 'Anguilla',
      'AQ': 'Antarctica',
      'AG': 'Antigua and Barbuda',
      'AR': 'Argentina',
      'AM': 'Armenia',
      'AW': 'Aruba',
      'AU': 'Australia',
      'AT': 'Austria',
      'AZ': 'Azerbaijan',
      'BS': 'Bahamas',
      'BH': 'Bahrain',
      'BD': 'Bangladesh',
      'BB': 'Barbados',
      'BY': 'Belarus',
      'BE': 'Belgium',
      'BZ': 'Belize',
      'BJ': 'Benin',
      'BM': 'Bermuda',
      'BT': 'Bhutan',
      'BO': 'Bolivia, Plurinational State of',
      'BQ': 'Bonaire, Sint Eustatius and Saba',
      'BA': 'Bosnia and Herzegovina',
      'BW': 'Botswana',
      'BV': 'Bouvet Island',
      'BR': 'Brazil',
      'IO': 'British Indian Ocean Territory',
      'BN': 'Brunei Darussalam',
      'BG': 'Bulgaria',
      'BF': 'Burkina Faso',
      'BI': 'Burundi',
      'KH': 'Cambodia',
      'CM': 'Cameroon',
      'CA': 'Canada',
      'CV': 'Cape Verde',
      'KY': 'Cayman Islands',
      'CF': 'Central African Republic',
      'TD': 'Chad',
      'CL': 'Chile',
      'CN': 'China',
      'CX': 'Christmas Island',
      'CC': 'Cocos (Keeling) Islands',
      'CO': 'Colombia',
      'KM': 'Comoros',
      'CG': 'Congo',
      'CD': 'Congo, the Democratic Republic of the',
      'CK': 'Cook Islands',
      'CR': 'Costa Rica',
      'CI': 'Côte d\'Ivoire',
      'HR': 'Croatia',
      'CU': 'Cuba',
      'CW': 'Curaçao',
      'CY': 'Cyprus',
      'CZ': 'Czech Republic',
      'DK': 'Denmark',
      'DJ': 'Djibouti',
      'DM': 'Dominica',
      'DO': 'Dominican Republic',
      'EC': 'Ecuador',
      'EG': 'Egypt',
      'SV': 'El Salvador',
      'GQ': 'Equatorial Guinea',
      'ER': 'Eritrea',
      'EE': 'Estonia',
      'ET': 'Ethiopia',
      'FK': 'Falkland Islands (Malvinas)',
      'FO': 'Faroe Islands',
      'FJ': 'Fiji',
      'FI': 'Finland',
      'FR': 'France',
      'GF': 'French Guiana',
      'PF': 'French Polynesia',
      'TF': 'French Southern Territories',
      'GA': 'Gabon',
      'GM': 'Gambia',
      'GE': 'Georgia',
      'DE': 'Germany',
      'GH': 'Ghana',
      'GI': 'Gibraltar',
      'GR': 'Greece',
      'GL': 'Greenland',
      'GD': 'Grenada',
      'GP': 'Guadeloupe',
      'GU': 'Guam',
      'GT': 'Guatemala',
      'GG': 'Guernsey',
      'GN': 'Guinea',
      'GW': 'Guinea-Bissau',
      'GY': 'Guyana',
      'HT': 'Haiti',
      'HM': 'Heard Island and McDonald Islands',
      'VA': 'Holy See (Vatican City State)',
      'HN': 'Honduras',
      'HK': 'Hong Kong',
      'HU': 'Hungary',
      'IS': 'Iceland',
      'IN': 'India',
      'ID': 'Indonesia',
      'IR': 'Iran, Islamic Republic of',
      'IQ': 'Iraq',
      'IE': 'Ireland',
      'IM': 'Isle of Man',
      'IL': 'Israel',
      'JM': 'Jamaica',
      'JP': 'Japan',
      'JE': 'Jersey',
      'JO': 'Jordan',
      'KZ': 'Kazakhstan',
      'KE': 'Kenya',
      'KI': 'Kiribati',
      'KP': 'Korea, Democratic People\'s Republic of',
      'KR': 'Korea, Republic of',
      'KW': 'Kuwait',
      'KG': 'Kyrgyzstan',
      'LA': 'Lao People\'s Democratic Republic',
      'LV': 'Latvia',
      'LB': 'Lebanon',
      'LS': 'Lesotho',
      'LR': 'Liberia',
      'LY': 'Libya',
      'LI': 'Liechtenstein',
      'LT': 'Lithuania',
      'LU': 'Luxembourg',
      'MO': 'Macao',
      'MK': 'Macedonia, the Former Yugoslav Republic of',
      'MG': 'Madagascar',
      'MW': 'Malawi',
      'MY': 'Malaysia',
      'MV': 'Maldives',
      'ML': 'Mali',
      'MT': 'Malta',
      'MH': 'Marshall Islands',
      'MQ': 'Martinique',
      'MR': 'Mauritania',
      'MU': 'Mauritius',
      'YT': 'Mayotte',
      'MX': 'Mexico',
      'FM': 'Micronesia, Federated States of',
      'MD': 'Moldova, Republic of',
      'MC': 'Monaco',
      'MN': 'Mongolia',
      'ME': 'Montenegro',
      'MS': 'Montserrat',
      'MA': 'Morocco',
      'MZ': 'Mozambique',
      'MM': 'Myanmar',
      'NA': 'Namibia',
      'NR': 'Nauru',
      'NP': 'Nepal',
      'NL': 'Netherlands',
      'NC': 'New Caledonia',
      'NZ': 'New Zealand',
      'NI': 'Nicaragua',
      'NE': 'Niger',
      'NG': 'Nigeria',
      'NU': 'Niue',
      'NF': 'Norfolk Island',
      'MP': 'Northern Mariana Islands',
      'NO': 'Norway',
      'OM': 'Oman',
      'PK': 'Pakistan',
      'PW': 'Palau',
      'PS': 'Palestine, State of',
      'PA': 'Panama',
      'PG': 'Papua New Guinea',
      'PY': 'Paraguay',
      'PE': 'Peru',
      'PH': 'Philippines',
      'PN': 'Pitcairn',
      'PL': 'Poland',
      'PT': 'Portugal',
      'PR': 'Puerto Rico',
      'QA': 'Qatar',
      'RE': 'Réunion',
      'RO': 'Romania',
      'RU': 'Russian Federation',
      'RW': 'Rwanda',
      'BL': 'Saint Barthélemy',
      'SH': 'Saint Helena, Ascension and Tristan da Cunha',
      'KN': 'Saint Kitts and Nevis',
      'LC': 'Saint Lucia',
      'MF': 'Saint Martin (French part)',
      'PM': 'Saint Pierre and Miquelon',
      'VC': 'Saint Vincent and the Grenadines',
      'WS': 'Samoa',
      'SM': 'San Marino',
      'ST': 'Sao Tome and Principe',
      'SA': 'Saudi Arabia',
      'SN': 'Senegal',
      'RS': 'Serbia',
      'SC': 'Seychelles',
      'SL': 'Sierra Leone',
      'SG': 'Singapore',
      'SX': 'Sint Maarten (Dutch part)',
      'SK': 'Slovakia',
      'SI': 'Slovenia',
      'SB': 'Solomon Islands',
      'SO': 'Somalia',
      'ZA': 'South Africa',
      'GS': 'South Georgia and the South Sandwich Islands',
      'SS': 'South Sudan',
      'ES': 'Spain',
      'LK': 'Sri Lanka',
      'SD': 'Sudan',
      'SR': 'Suriname',
      'SJ': 'Svalbard and Jan Mayen',
      'SZ': 'Swaziland',
      'SE': 'Sweden',
      'CH': 'Switzerland',
      'SY': 'Syrian Arab Republic',
      'TW': 'Taiwan, Province of China',
      'TJ': 'Tajikistan',
      'TZ': 'Tanzania, United Republic of',
      'TH': 'Thailand',
      'TL': 'Timor-Leste',
      'TG': 'Togo',
      'TK': 'Tokelau',
      'TO': 'Tonga',
      'TT': 'Trinidad and Tobago',
      'TN': 'Tunisia',
      'TR': 'Turkey',
      'TM': 'Turkmenistan',
      'TC': 'Turks and Caicos Islands',
      'TV': 'Tuvalu',
      'UG': 'Uganda',
      'UA': 'Ukraine',
      'AE': 'United Arab Emirates',
      'GB': 'United Kingdom',
      'US': 'United States',
      'UM': 'United States Minor Outlying Islands',
      'UY': 'Uruguay',
      'UZ': 'Uzbekistan',
      'VU': 'Vanuatu',
      'VE': 'Venezuela, Bolivarian Republic of',
      'VN': 'Viet Nam',
      'VG': 'Virgin Islands, British',
      'VI': 'Virgin Islands, U.S.',
      'WF': 'Wallis and Futuna',
      'EH': 'Western Sahara',
      'YE': 'Yemen',
      'ZM': 'Zambia',
      'ZW': 'Zimbabwe'
    };
    // </editor-fold>

    // <editor-fold desc='Patterns For Validation'>
    $scope.phoneType = new RegExp('^[\u0000-\u007F]{5,12}$');
    $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    $scope.CAPType = new RegExp('^[0-9]{5}$');
    $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');
    $scope.TitoloType = new RegExp('^[\u0000-\u007F]{2,10}$');
    $scope.CodEORIType = new RegExp('^.{13,17}$');
    $scope.String60LatinType = new RegExp('^[\u0000-\u00FF]{1,60}$');
    $scope.ProvinciaType = new RegExp('^[A-Z]{2}$');
    $scope.String60Type = new RegExp('^[\u0000-\u007F]{1,60}$');
    $scope.String80LatinType = new RegExp('^[\u0000-\u00FF]{1,80}$');
    $scope.String60LatinType = new RegExp('^[\u0000-\u00FF]{1,60}$');
    $scope.NumeroCivicoType = new RegExp('^[\u0000-\u007F]{1,8}$');
    // </editor-fold>

    $scope.prev = () => {
      $scope.user.accountData.lastStepSaved = 'account-data';
      store.set('registeringUser', $scope.user);
      $state.go('registration.account-data');
    };

    $scope.next = () => {
      if ($rootScope.userTypes[$scope.user.subscription.subscriptionType] === 'odin') {
        _validationService.isUsersPivaOrFiscalCodeMatchingWithOdinProvisioningInformation($scope.user)
          .then((result) => {
            if (result.data) {
              $scope.odinMessagePivaOrFiscalCodeMismatch = '';
              $scope.goNextPage();
            } else {
              $scope.odinMessagePivaOrFiscalCodeMismatch = 'PIVA / Codice Fiscale non corrispondenti con quelli caricati su TIM Digital Store.';
            }
          }, (error) => {
            $rootScope.alert('error', error);
          });
      } else {
        $scope.goNextPage();
      }
    };

    $scope.goNextPage = () => {
      if ($scope.user.organizationData.contactPerson.identityCardFile === '' || $scope.user.organizationData.contactPerson.identityCardFile === undefined) {
        $scope.identityCardMissing = true;
        return;
      } else {
        $scope.identityCardMissing = false;
      }

      store.set('registeringUser', $scope.user);
      $scope.buttonDisabled = true;
      $state.go('registration.contract-step1');
    };

    $scope.emptyIfFieldChanged = (dependentModel1, dependentModel2, dependentModel3) => {
      $parse(dependentModel1).assign($scope, '');
      if (dependentModel2) {
        $parse(dependentModel2).assign($scope, '');
      }
      if (dependentModel3) {
        $parse(dependentModel3).assign($scope, '');
      }
    };

    // <editor-fold desc='DatePicker'>

    $scope.dpOpened = {
      birthDate: false
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    $scope.autoOpen = ($event, opened) => {
      /* tslint:disable:no-string-literal */
      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    // </editor-fold>

    // <editor-fold desc='ChangePersonalFiles'>
    $scope.openAddPersonalFilesModal = (size) => {

      let AddPersonalFilesModal = $uibModal.open({
        animation: true,
        component: 'uploadPersonalFiles',
        controllerAs: 'vm',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return $scope.user;
          }
        }
      });

      AddPersonalFilesModal.result.then((data) => {
        if (data.user !== undefined) {
          $scope.user = data.user;
        }

        if (data.requiredFieldsMissing !== undefined) {
          $scope.identityCardMissing = data.requiredFieldsMissing;
        }
      }, () => {
        // ?
      });
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/organization-data/organization-data.controller.ts